var _excluded = ["appElement", "style", "header", "HeaderComponent", "confirmText", "cancelText", "message", "isAlert", "alertText", "isLoading", "isSubmitting"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef, useLayoutEffect, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { omit, isEmpty } from "lodash-es";
import Modal from "react-modal";
import Button from "../../components/button/Button";
import { useForceUpdate } from "../../helpers/hooks";
import LoadingAnimation from "../../components/loadinganimation/LoadingAnimation";
var ConfirmModal = function ConfirmModal(_ref) {
  var appElement = _ref.appElement,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$header = _ref.header,
    header = _ref$header === void 0 ? "Are you sure?" : _ref$header,
    _ref$HeaderComponent = _ref.HeaderComponent,
    HeaderComponent = _ref$HeaderComponent === void 0 ? "h3" : _ref$HeaderComponent,
    _ref$confirmText = _ref.confirmText,
    confirmText = _ref$confirmText === void 0 ? "Yes" : _ref$confirmText,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? "No" : _ref$cancelText,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? "" : _ref$message,
    _ref$isAlert = _ref.isAlert,
    isAlert = _ref$isAlert === void 0 ? false : _ref$isAlert,
    _ref$alertText = _ref.alertText,
    alertText = _ref$alertText === void 0 ? "OK" : _ref$alertText,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isSubmitting = _ref.isSubmitting,
    isSubmitting = _ref$isSubmitting === void 0 ? false : _ref$isSubmitting,
    props = _objectWithoutProperties(_ref, _excluded);
  var confirmModalButton = useRef();
  var _useForceUpdate = useForceUpdate(),
    _useForceUpdate2 = _slicedToArray(_useForceUpdate, 2),
    forceUpdateState = _useForceUpdate2[0],
    forceUpdate = _useForceUpdate2[1];
  useLayoutEffect(function () {
    if (props.isOpen) {
      if (confirmModalButton.current) {
        confirmModalButton.current.focus();
      } else {
        forceUpdate();
      }
    }
  }, [props.isOpen, forceUpdateState, forceUpdate]);
  useEffect(function () {
    var onKeyUp = function onKeyUp(event) {
      if (event.key === "Escape") {
        props.onCancel();
      }
    };
    window.addEventListener("keyup", onKeyUp, false);
    return function () {
      return window.removeEventListener("keyup", onKeyUp, false);
    };
  }, [props.onCancel]);
  return /*#__PURE__*/React.createElement(Modal, _extends({
    overlayClassName: "modal-overlay",
    className: classNames("confirm-modal-content", {
      "with-message": !isEmpty(message)
    })
  }, omit(props, "style", "header", "HeaderComponent", "confirmText", "cancelText", "isLoading", "isSubmitting"), {
    appElement: appElement || document.querySelector("div") || document.querySelector("body"),
    style: {
      content: style
    },
    aria: {
      busy: isLoading || isSubmitting
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "confirm-modal"
  }, /*#__PURE__*/React.createElement(HeaderComponent, {
    className: "confirm-header"
  }, header), message && /*#__PURE__*/React.createElement("p", {
    className: "confirm-content"
  }, message), (isLoading || isSubmitting) && /*#__PURE__*/React.createElement("div", {
    className: "loader-overlay"
  }, /*#__PURE__*/React.createElement(LoadingAnimation, null))), /*#__PURE__*/React.createElement("div", {
    className: "confirm-footer"
  }, isAlert ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "md",
    ref: confirmModalButton,
    id: "confirmModalButton",
    onClick: props.onConfirm
  }, alertText) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "destructive",
    onClick: props.onCancel,
    style: {
      marginRight: 10
    },
    disabled: isLoading || isSubmitting
  }, cancelText), /*#__PURE__*/React.createElement(Button, {
    variant: "confirm",
    ref: confirmModalButton,
    id: "confirmModalButton",
    onClick: props.onConfirm,
    disabled: isLoading,
    isLoading: isSubmitting
  }, confirmText))));
};
ConfirmModal.propTypes = {
  appElement: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  style: PropTypes.object,
  header: PropTypes.node,
  HeaderComponent: PropTypes.any,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmText: PropTypes.node,
  cancelText: PropTypes.node,
  message: PropTypes.node,
  isAlert: PropTypes.bool,
  alertText: PropTypes.node,
  isLoading: PropTypes.bool,
  isSubmitting: PropTypes.bool
};
export default ConfirmModal;
//# sourceMappingURL=ConfirmModal.js.map